import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import { Link } from 'react-router';
import _get from 'lodash/get';
import Promise from 'bluebird';
import cn from 'classname';

const Main = props => {
	const { good, intl, handleOrder, saveUpForGood, user } = props;
	const { title, description } = _get(good, `translations.${intl.language}`, good) || good;
	let buttonText = 'Order';
	switch (true) {
		case user.contest_points < good.price && user.preferred_gift !== good.id:
			buttonText = 'Want save-up for';
			break;
		case user.contest_points < good.price && user.preferred_gift === good.id:
			buttonText = 'Stop save-up for';
			break;
	}
	const isSavingForGood = user.preferred_gift === good.id;
	return (
		<div className="single-gift-container">
			<Link to='market' className="back-link">
				<span className="market-arrow">
						&#11013;
				</span>
				{intl('Вернуться к списку товаров')}
			</Link>
			<div className="shop gift-card">
				<div className="gift-card-info__container">
					<div
						className="gift-card__image"
						style={{backgroundImage:`url("${good.image}")`}}>
					</div>
					<div className="gift-card__description">
						<div className="title">{title}</div>
						<div className="category">
							{good.category && good.category[`name_${intl.language}`]}
						</div>
						<div  className="good__description">{ description }</div>
						<div  className="good__order">
							<span className="price">
								{ good.price } QUID
							</span>
							<button
								className={cn({
									'btn': true,
									'btn_order': user.contest_points < good.price,
									'btn_non-active': isSavingForGood && user.contest_points < good.price,
									'btn_hover': true
								})}
								onClick={e => {
									if (user.contest_points >= good.price) {
										const target = e.target;
										const innerText = e.target.innerHTML;
										handleOrder({good, user, marketLang: intl.language})
											.then(() => {
												target.innerHTML = intl('Order was excepted');
												return Promise.delay(2000);
											})
											.then(() => {target.innerHTML = innerText;});
									} else {
										saveUpForGood(user.preferred_gift !== good.id ? good.id : null);
									}
								}}
							>
								{intl(buttonText)}
							</button>
						</div>
					</div>
				</div>
			</div>
			<Link className="btn back-button" to='market'>
				{intl('Вернуться к списку товаров')}
			</Link>
		</div>
	);
};

class MainWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			goodOfCard: {}
		};
	}
	componentDidMount() {
		axios.get(`v2/bonus-market?${qs.stringify({filters: {id: [this.props.goodCardNumber]}})}`)
			.then(response => this.setState({goodOfCard: response.data.rows[0]}));
	}
	render() {
		return <Main {...this.props} good={this.state.goodOfCard} />;
	}
}

Main.propTypes = {
	intl: PropTypes.func,
	handleOrder: PropTypes.func,
	saveUpForGood: PropTypes.func,
	user: PropTypes.object,
	goods: PropTypes.object
};

MainWrapper.propTypes = {
	goodCardNumber: PropTypes.number
};

export default MainWrapper;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/goodCard/main.js